import './index.scss';

import React from 'react';

import { getMarketingInfo } from '@api/home/detail/addCart/useAddCart';
import { PageData } from '@api/home/detail/types';
import { Image, Switch } from '@ui-pc';

// eta发货时间元素
export const EtaTag = (props: {
  className?: string
  productInfo?: any
  style?: any
}) => {
  const { className, productInfo, style } = props
  const { deliveryTime, deliveryTimeImage } = productInfo
  //console.log(productInfo);
  return (
    <>
      {deliveryTime != '' && deliveryTime != undefined && (
        <div className={`marketing-wrap ${className}`} style={{ ...style }}>
          {deliveryTimeImage != '' && deliveryTimeImage != undefined && (
            <Image
              wrapperClassName="marketing-delivery-img"
              preview={false}
              key={deliveryTimeImage}
              src={deliveryTimeImage}
              alt=""
            />
          )}
          <div
            className="marketing-delivery-content"
            dangerouslySetInnerHTML={{ __html: deliveryTime }}></div>
        </div>
      )}
    </>
  )
}

export default function MarketingText(props: PageData['productInfo']) {
  const {
    stocks,
    isOutStockCanBuy,
    deliveryTime,
    productsStatus,
    presaleDeliveryTime,
    customTips,
    isCart,
    isDrawer,
    status
  } = props

  // const { isPreOrder, isSoldOut } = getMarketingInfo({
  //   stocks,
  //   productsStatus,
  //   isOutStockCanBuy
  // })

  const proStatus = status || productsStatus

  // 逻辑: 暂时用同一个字段deliveryTime表示文案，status=3表示预售，显示预售icon, statue=1, 显示有库存icon
  // 01-12 逻辑：delivery_time_image 表示icon,delivery_time表示文案。
  return (
    <>
      <Switch either={[1, 3].includes(proStatus) && !!deliveryTime}>
        <div
          className={`${!isCart && !isDrawer ? 'detail-marketing' : ''}${
            isDrawer ? 'drawer-marketing-style' : ''
          }`}>
          {/* <Switch either={!!customTips}>
            <div className={`marketing-text-shipping ${isCart ? 'small' : ''}`}>
              {customTips}
            </div>
          </Switch> */}
          {/* ==1: In Stock. + Dispatch within 48 hours */}
          {/* ==3: Expect it in : 5-14 days */}
          <Switch either={proStatus === 1 || proStatus === 3}>
            {/* {isCart ? (
              <span
                className={`marketing-delivery-time ${isDrawer ? 'full' : ''} ${isCart ? 'cart' : ''
                  }`}>
                {proStatus === 1 ? (
                  <i className="iconfont icon-a-InStock"></i>
                ) : (
                  <i className="iconfont icon-Expect"></i>
                )}
                <span dangerouslySetInnerHTML={{ __html: deliveryTime }}></span>
              </span>
            ) : (
              <span className="marketing-delivery-green">
                <span dangerouslySetInnerHTML={{ __html: deliveryTime }}></span>
              </span>
            )} */}
            <EtaTag
              className={
                isCart
                  ? `marketing-delivery-time ${isDrawer ? 'full' : ''} ${
                      isCart ? 'cart' : ''
                    }`
                  : 'marketing-delivery-green'
              }
              productInfo={props}
            />
          </Switch>
        </div>
      </Switch>
    </>
  )
}
